import { createContext, useContext } from 'react';
import type { PermissionCode, SessionUser } from '@amai/contracts';

export interface AuthState {
  user: SessionUser | null;
  /**
   * `unreachable`: há sessão guardada, mas não deu para confirmá-la — API
   * fora, rede caída ou limite de requisições. A sessão NÃO é apagada: só um
   * `401` diz que ela acabou.
   */
  status: 'loading' | 'authenticated' | 'anonymous' | 'unreachable';
  /** Tenta confirmar a sessão de novo, depois de `unreachable`. */
  retrySession: () => void;
  signIn: (email: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
  /** Checagem de permissão na UI. O servidor checa de novo — isto é só UX. */
  can: (code: PermissionCode) => boolean;
}

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth precisa estar dentro de <AuthProvider>');
  return context;
}

/** Atalho para esconder ação que o perfil não pode executar. */
export function usePermission(code: PermissionCode): boolean {
  return useAuth().can(code);
}
